//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import UnsupportedTemplate from "../../templates/unsupported";
import ThumbnailTemplate from "../../templates/thumbnail";
import FeaturedTemplate from "../../templates/featured";
export default {
  components: {
    "template-thumbnail": ThumbnailTemplate,
    "template-featured": FeaturedTemplate,
    "template-unsupported": UnsupportedTemplate
  },
  props: {
    spec: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      customData: null
    };
  },
  computed: {
    template: function template() {
      var name = "template-".concat(this.spec.template.replace("/", "-"));
      var strict = false;

      if (strict) {
        return name;
      } else {
        if (this.$options.components[name]) {
          return name;
        }

        return "template-unsupported";
      }
    }
  },
  methods: {
    $ready: function $ready() {
      var onClick = this.spec.onClick ? {
        onClick: this.spec.onClick
      } : {};
      this.customData = Object.assign(onClick, this.spec.data);
    }
  }
};